import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProfileService } from '../services/profile.service';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ADResolverService {
  constructor(private profileInfo: ProfileService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.profileInfo.getProfileInfo().pipe(
      catchError((error) => {
        return empty();
      })
    );
  }
}
